import { render, staticRenderFns } from "./kpi1.vue?vue&type=template&id=64acdb64&scoped=true&"
import script from "./kpi1.vue?vue&type=script&lang=js&"
export * from "./kpi1.vue?vue&type=script&lang=js&"
import style0 from "./kpi1.vue?vue&type=style&index=0&id=64acdb64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64acdb64",
  null
  
)

export default component.exports